<template>
<div>
  <div id='' class='gPageBorder' v-loading='loading'>
    <el-form class='gForm' label-position="right" ref="firm" :rules='rules' label-width="12.5%" :model='firm' style=''>
      <el-form-item :label="$t('app_firmware')" prop='item'>
        <el-select style='' v-model="form.item" clearable :placeholder="$t('app_select')" @change='fwChange'>
          <el-option
            v-for="item in tableData"
            :key="item.id"
            :label="item.firmwareName"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('app_version')" prop='version'>
        <el-label>{{form.item.version}}</el-label>
      </el-form-item>
      <el-form-item :label="$t('app_type')" prop='type'>
        <el-label>{{form.item.type}}</el-label>
      </el-form-item>
      <el-form-item :label="$t('app_pushType')" prop='pushType'>
        <el-select style='' v-model="form.pushType"  :placeholder="$t('app_select')" @change='selectChange'>
          <el-option
            v-for="item in pushType"
            :key="item.vl"
            :label="item.label"
            :value="item.vl">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-show='form.pushType === 0' :label="$t('app_distributor')" prop="mechanism">
          <!--<el-select style='' v-model="form.mechanism" clearable :placeholder="$t('app_select')" @change='selectChange'>-->
          <!--<el-option-->
            <!--v-for="item in mechs"-->
            <!--:key="item.mechanismid"-->
            <!--:label="item.mechanismname"-->
            <!--:value="item.mechanismid">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
      </el-form-item>


      <el-form-item  v-show='form.pushType === 1' :label="$t('app_deviceNo')" prop="">
         <!-- <el-input v-model='dNo' style='width:50%;'></el-input> -->
        <AutoTerno @on-result-change="onDvInputChange"></AutoTerno>
      </el-form-item>

      <el-form-item v-show="form.pushType === 2" :label="$t('app_mdFile')">

            <a class='aSc' style='' :href="downUrl" :title="$t('app_downExp')" target="_blank">{{$t('app_downTplFile')}}</a>

            <el-upload
              class="upload-demo"
              name='fileUpload'
              :action="$fileExcelUlUrl"
              :before-upload="srcBefore"
              :on-success="srcSuccess"
              :file-list="srcList">
              <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            </el-upload>
        </el-form-item>

        <el-form-item  v-show="form.pushType === 2" :label="$t('app_deviceNum')">
          <el-label style='width:25%;'>{{devices}}{{$t('app_amechine')}}</el-label>
        </el-form-item>

      <el-form-item>
        <!-- <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button> -->
        <el-button  type='primary' style='' @click="submit">{{$t('app_submit')}}</el-button>

      </el-form-item>

    </el-form>


  </div>

    <div class="gTopMg gPageBorder" v-loading='hLoading'>
      <p class='gPTitle'>{{$t('app_operateHis')}}</p>
      <el-table :data="arrdatas" border>
        <el-table-column
          prop="opeTime"
          :label="$t('lin_global.time')">
        </el-table-column>
        <el-table-column
          prop="mechanismName"
          :label="$t('lin_global.label_areaid')">
        </el-table-column>
        <el-table-column
          prop="pushType"
          :label="$t('lin_global.tuisongleixing')"
        :formatter="formatStatus">
          <template slot-scope="scope">
            <label>{{missionNames[scope.row.pushType]}}</label>
          </template>
        </el-table-column>
        <el-table-column
          prop="successNums"
          :label="$t('lin_global.chenggong')">
        </el-table-column>
        <el-table-column
          prop="failNums"
          :label="$t('lin_global.shibai')">
        </el-table-column>
        <el-table-column
          width='80'
          align='center'
          :label="$t('lin_global.ope')">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.failNum > 0" @click.stop="resXiafa(scope.row.pushType,scope.row.mechId)" type="text">{{$t('lin_global.chongxintuisong')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('lin_global.chongxintuisong')" placement="top">
              <el-button type='text' v-if="scope.row.failNums > 0" @click.stop="resXiafa(scope.row)"><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      <div class='gPgDiv'>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords"
          class="gPg">
          </el-pagination>
      </div>
    </div>

</div>
</template>

<style>
</style>

<script>
  import axios from 'axios'
  import AutoTerno from '../../global/TernoAutoCtrl'
  import {baseurl,focusEvent,urlAssets} from '../../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector,AutoTerno
    },
    data () {
      var itemCheck = (rule, value, callback) => {
        if (!this.form.item) {
          callback(new Error(this.$t('app_select')));
        } else {
          callback()
        }
      }
      var that =  this
      return {
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.form.mechanism = value
            that.selectChange(value)
          }
        },
        loading: false,
        exInfo: '',
        arrdatas:[],
        totalRecords: 0,
        srcList: [],
        hLoading: false,
        currentPage: 1,
        restaurants: [],
        missionNames: {
         '0': this.$t('app_distributor'),'1': this.$t('app_dv'), '2':this.$t('app_fileImport'),
        },
        devices: 0,
        mechanismId: window.localStorage['mechanismId'],
        dNo: '',
        info: '',
        pushType: [
          {label: this.$t('app_distributor'), vl: 0},
          {label: this.$t('app_dv'), vl: 1},
          {label: this.$t('app_fileImport'), vl: 2},
        ],
        tableData: [],
        fatherList: [],
        mechs: [],
        form: {
          item: '',
          pushType: 0,
          mechanism: '',
          fileNo: ''
        },
        rules: {
          item: [
            { required: true, message: this.$t('app_select'), trigger: 'change', validator: itemCheck }
          ]
        }
      }
    },
    computed: {
      downUrl () {
        return this.$host + '/tms-server-web/model/terminalNos.xlsx'
      }
    },
    methods: {
      resXiafa:function(row){
        //console.log()
        //return
        this.hLoading = true
        this.$repush(row.pushType, row.opeTime, row.objectId, (res) => {
          this.hLoading = false
          if(res.status == 200){
            this.$message.success(res.message);
            this.getList(1,row.objectId);
          }else{
            this.$message.error(res.message)
          }
        }, (error) => {
          this.hLoading = false
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      handleCurrentChange: function (val) {
        this.currentPage = val
        
        this.getList(this.currentPage,this.form.item.id)
        
      },
      handleSizeChange: function (val) {
        this.pageSize = val
        
        this.getList(this.currentPage,this.form.item.id)
      },
      getList:function(page,id){
        this.currentPage = page;
        //var params = {ota_rom_id:id,page:page,rows:this.pageSize}
        this.hLoading = true
        this.$pushRecords(page, this.$gRow, '4', id, (res) => {
          console.log(res.data)
          this.hLoading = false
          if(res.status == 200){
            this.arrdatas = res.data;
            this.totalRecords = res.total;
          }else{
            this.$message.error(res.message)
          }
        }, (error) => {
          this.hLoading = false
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      onDvInputChange (vl) {
        this.dNo = vl
      },
      srcBefore (file) {
        // console.log(file)
        window[this.$route.path] = 1
        /*var name = file.name
        if (name === 'part0.zip') {
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } */
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        // console.log('exres', res)
        if (res.status === 200) {
          this.srcList = [{name: file.name}]
          this.exInfo = res.data
          this.exInfo.file = file.name
          this.devices = res.data.terNums
          //this.hBlur('fm')
        } else {
          if (this.exInfo.file) {
            this.srcList = [{name: this.exInfo.file}]
          } else {
            this.srcList = []
          }
          this.$message.error(res.message)
        }
      },
      submit () {
        this.$refs['firm'].validate((valid) => {
          if (valid) {
            var tid = ''
            var type = 0
            if (this.form.pushType === 0) {
              if (!this.form.mechanism) {
                this.$message.error(this.$t('app_selectChannel'))
                return
              } else {
                type = 0
                tid = this.form.mechanism
              }
            } else if (this.form.pushType === 1) {
              if (!this.dNo) {
                this.$message.error(this.$t('app_pleaseInputNo'))
                return
              } else {
                type = 1
                tid = this.dNo
              }
            }
            if (this.form.pushType === 2 && !this.exInfo) {
              this.$message.error(this.$t('app_plsUpl'))
              return
            }
            // console.log(this.form, this.dNo)
            this.loading = 1
            var fn = this.exInfo.fileNo ? this.exInfo.fileNo : ''
            this.$pushFirmware(fn,this.form.item.id, this.form.pushType, tid, (res) => {
              this.loading = 0
              this.$message(res.message)
              if (this.form.item.id) {
                this.getList(1,this.form.item.id)
              }
            }, () => {
              this.loading = 0
              this.$message.error(this.$t('app_rqsError'))
            })

          } else {
            return false
          }
        })
      },
      fwChange (vl) {
        // console.log(vl)
        if (vl) {
          this.getList(this.currentPage,vl.id)
        } else {
          this.arrdatas = []
        }
      },
      getFmList () {
        this.loading = 1
        var type = this.fType ? this.fType : ''
        var name = this.qName ? this.qName : ''
        var status = '2'
        this.$getFirmwareList(this.$gRow, this.$getWPage('firmwarePage'), this.mechanismId, name, type, status, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      }
    },
    mounted () {
      this.getFmList()


      var params = {mechId:window.localStorage['mechanismId']};
      axios.post(`${baseurl}/terminal/terminalNoList.do`,params).then(res=>{
        
        this.restaurants = res.data.data;
      })
      
    

//      this.$getChannelList(999, 1, (res) => {
//        if (res.status === 200) {
//          console.log(res)
//          this.mechs = res.data
//        } else {
//          this.$message.error(res.message)
//        }
//      }, () => {
//        this.$message.error(this.$t('app_rqsError'))
//      })
    }
  }
</script>



// WEBPACK FOOTER //
// push.vue?5feb7f0c